import { Box, Stack, SxProps } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { Custom } from "components";

type Props = {
  sx?: SxProps;
  color?: string;
  onClick: () => void;
};

export const Logo = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <Stack
      sx={{ cursor: "pointer", ...props.sx }}
      direction="row"
      alignItems="center"
      onClick={props.onClick}
      spacing={theme.spacing.xs}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          backgroundColor: theme.color.primary.color,
          color: theme.color.primary.text,
          fontFamily: '"Space Mono", monospace',
          fontSize: theme.font.xxs,
          fontWeight: theme.font.bold,
          borderRadius: theme.border.square,
          boxShadow: `2px 2px 0px 0px ${theme.color.border.color}`,
        }}
      >
        SR
      </Box>
      <Custom.Typography
        noWrap
        variant="h4"
        color={props.color ?? theme.color.font.color}
        weight={theme.font.bold}
        sx={{
          letterSpacing: "-0.01em",
          display: "flex",
          alignItems: "center",
          gap: theme.spacing.xxs,
          textTransform: "uppercase",
          fontFamily: '"Space Mono", monospace',
          fontSize: theme.font.sm,
        }}
      >
        {t.navbar.title}
      </Custom.Typography>
    </Stack>
  );
};